/**
 * @copyright Elmelo Ltd.
 */

import React from 'react'

import {connect} from 'react-redux'
import * as actions from '../../rdx/actions'

/**
 */
class AuthLogIn extends React.PureComponent
{
    /**
     */
    // constructor( props )
    // {
    //     super( props )
    // }

    /**
     */
    render()
    {
        return (
            <div>
                <h1>Authenticating ...</h1>
            </div>
            )
    }

    /**
     */
    componentDidMount()
    {
        this.VerifyAuth()
            .then( data => {} )
            .catch( data => {} )
    }

    /**
     */
    VerifyAuth = async () =>
    {
        try
        {
            return {msg: 'OK'}
        }
        catch( err )
        {
            return Promise.reject( err )
        }
    }
}   // class Auth_LogIn

/**
 */
const mapStateToProps = (state) =>
{
    return state
}   //

/**
 */
export default connect(mapStateToProps, actions)( AuthLogIn )


